var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { formatCurrency, getMoneyFormat } from '../helpers/currencies';
import { docReady } from '../helpers/doc-ready';
import { getProductsByTag } from '../helpers/admin-api';
import { getAvailableCurrencies } from '../helpers/currencies';
const renderSkeleton = (containerSize) => {
    const amount = containerSize == 'small' ? 2 : 10;
    return Array.from({ length: amount }, (_, i) => `<div class="skeleton-card ${containerSize}">
    <span class="skeleton-card__image"></span>
    <span class="skeleton-card__text"></span>
    </div>`);
};
const featuredProducts = () => __awaiter(void 0, void 0, void 0, function* () {
    const scriptTag = document.querySelector('#featured-products-state');
    const state = scriptTag ? JSON.parse(scriptTag.innerHTML) : null;
    if (!state)
        return;
    const featuredProductsContainers = document.querySelectorAll('[data-related-products-list]');
    if (featuredProductsContainers) {
        Array.from(featuredProductsContainers).forEach((featuredProductsContainer) => __awaiter(void 0, void 0, void 0, function* () {
            const itemsContainer = featuredProductsContainer.querySelector('[data-related-products-items]');
            const containerSize = itemsContainer.dataset.relatedProductsItems;
            const skeleton = renderSkeleton(containerSize);
            itemsContainer.innerHTML = `${skeleton.join('')}`;
            const products = yield getProductsByTag(state.tag, state.isoCode, state.handle, state.sort_key, state.reverse);
            const currencies = yield getAvailableCurrencies();
            const selectedCountry = currencies.availableCountries.filter((country) => country.isoCode === state.isoCode)[0];
            const featuredProductsSection = document.querySelector('.shopify-section--product-recommendations');
            const featuredProductsBlock = document.querySelector('.product-info__related-products');
            if (!products) {
                if (featuredProductsSection) {
                    featuredProductsSection.remove();
                }
                if (featuredProductsBlock) {
                    featuredProductsBlock.remove();
                }
                return;
            }
            itemsContainer.innerHTML = '';
            let blendedCards = false;
            if (itemsContainer.classList.contains('product-list--blended-cards')) {
                blendedCards = true;
            }
            let largestApsectRatio = 0;
            products.forEach(({ node }, i) => {
                const productItem = document.createElement('product-card');
                if (blendedCards) {
                    productItem.classList.add('product-card--blends');
                }
                productItem.setAttribute('data-related-product-card', '');
                productItem.classList.add('product-card', 'bg-custom', 'text-custom');
                productItem.innerHTML = `
        <div class="product-card__figure"></div>
        <div class="product-card__info">
          <div class="v-stack gap-0.5 w-full">
            <span class="product-card__title">
                <a href="" class="bold"></a>
            </span>
            <price-list class="price-list">
                <sale-price class="text-subdued"></sale-price>
            </price-list>
          </div>
        </div>`;
                const imageWrapper = productItem.querySelector('.product-card__figure');
                const title = productItem.querySelector('.product-card__title a');
                const price = productItem.querySelector('.price-list sale-price');
                const moneyFormat = getMoneyFormat(selectedCountry);
                const money = formatCurrency(Number(node.contextualPricing.priceRange.maxVariantPrice.amount) * 100, moneyFormat);
                const imageAnchor = document.createElement('a');
                imageAnchor.classList.add('product-card__image', 'product-card__image--primary', 'aspect-natural');
                imageAnchor.setAttribute('href', `/products/${node.handle}`);
                const image = document.createElement('img');
                image.setAttribute('src', node.featuredImage.url);
                image.setAttribute('class', 'product-item__primary-image');
                image.setAttribute('width', node.featuredImage.width);
                image.setAttribute('height', node.featuredImage.height);
                imageAnchor.appendChild(image);
                imageWrapper.appendChild(imageAnchor);
                const aspectRatio = node.featuredImage.width / node.featuredImage.height;
                if (aspectRatio > largestApsectRatio) {
                    largestApsectRatio = aspectRatio;
                }
                title.setAttribute('href', `/products/${node.handle}`);
                title.innerText = node.title;
                price.innerText = `${money}`;
                itemsContainer.appendChild(productItem);
            });
        }));
    }
    const carouselControl = document.querySelectorAll('[data-related-products-control]');
    const scrollAnim = (element, position) => {
        element.scrollTo({
            left: position,
            behavior: 'smooth',
        });
    };
    carouselControl.forEach((control) => {
        control.addEventListener('click', () => {
            const controlTarget = control.getAttribute('aria-controls');
            const targetCarousel = document.querySelector('#' + controlTarget);
            const scrollAmount = targetCarousel === null || targetCarousel === void 0 ? void 0 : targetCarousel.querySelector('product-card').offsetWidth;
            if (control.hasAttribute('data-control-prev')) {
                scrollAnim(targetCarousel, targetCarousel.scrollLeft - scrollAmount);
            }
            else {
                scrollAnim(targetCarousel, targetCarousel.scrollLeft + scrollAmount);
            }
        });
    });
});
docReady(() => {
    featuredProducts();
});
